import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Carousel from "nuka-carousel";
import { Link } from "react-router-dom";

class Pharmacy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false, // Modal visibility state

      fname: "",
      lname: "",
      email: "",
      subject: "Demo for Pharmacy Software",
      message: "",
      loader: false,
    };
  }

  // Method to handle opening the modal
  // ===================================
  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, fname: "", lname: "", email: "" });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // =====================
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loader: true });
    const { fname, lname, email, subject, message } = this.state;
    try {
      const response = await fetch(
        "https://myhrms.anantayitsolutions.com/WebInquiry/AddWebInquiryDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: fname,
            lastName: lname,
            email: email,
            subject: subject,
            remarks: message,
          }),
        }
      );

      if (response.ok) {
        alert(" information submitted successfully!");
        const data = await response.json();
        console.log(data);
        this.closeModal();
      } else {
        alert("There was an error submitting the form.");
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      alert("There was an error submitting the form.");
      console.error(error);
    }

    this.setState({
      fname: "",
      lname: "",
      email: "",
      subject: "",
      message: "",
      loader: false,
    });
  };
  render() {
    const { isModalOpen, fname, lname, email, subject, message } = this.state;
    return (
      <>
        <section className="Portfolios-odd">
          <div className="container">
            <div className="section-title text-center" data-aos="fade-up">
              <h2 className="text-light">Pharmacy Software</h2>
            </div>

            <div className="row text-light">
              {/* Left Section (Details) */}
              <div className="col-12 col-md-6">
                <div className="work-content pr-md-5">
                  <div className="work-content pr-md-5">
                    <h4
                      style={{
                        // fontWeight: "600",
                        fontSize: "25px",
                        color: "#f39c12",
                      }}
                    >
                      Pharmacy Software
                    </h4>
                    <div className="pdis mt-4">
                      {/* <h5 className="text-light">Details</h5> */}
                      <span>
                        Our Software is comprehensive hospital management
                        software designed to enhance efficiency and patient
                        care. With its intuitive interface and advanced
                        features, It 3.0 can help hospitals streamline their
                        operations, improve financial management, and gain
                        valuable insights into their performance.
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={this.openModal}
                    className="mt-5"
                    style={{
                      padding: "14px 28px",
                      color: "white",
                      border: "none",
                      borderRadius: "50px",
                      fontSize: "15px",
                      fontWeight: "bold",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      width: "auto",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      backgroundColor: "orange",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "darkorange";
                      e.target.style.boxShadow =
                        "0 6px 12px rgba(0, 0, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "orange";
                      e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
                    }}
                  >
                    BOOK YOUR FREE DEMO
                  </button>

                  <div className="d-flex mt-3">
                    <FontAwesomeIcon
                      // icon={faPhoneSquare   }
                      icon={faPhone}
                      style={{ marginRight: "8px", marginTop: "8px", order: 1 }} // Icon on the left
                    />
                    <span
                      // to="tel:+919712312188"
                      style={{ order: 2, color: "white" }}
                    >
                      +91 97123 12188
                    </span>
                  </div>

                  <div className="mt-3 md-3">
                    <ul>
                      <div>
                        <input type="checkbox" checked />
                        <label className="ms-2">
                          Use Trail Version for 30 days before taking any
                          decision.
                        </label>
                      </div>

                      <div>
                        <input type="checkbox" id="customization" checked />
                        <label className="ms-2" htmlFor="customization">
                          We do customization as per clients need and
                          requirement.
                        </label>
                      </div>
                      <div>
                        <input type="checkbox" id="support" checked />
                        <label className="ms-2" htmlFor="support">
                          1 Year Free Online, Telephonic, Chat Support.
                        </label>
                      </div>
                      <div>
                        <input type="checkbox" id="installation" checked />
                        <label className="ms-2" htmlFor="installation">
                          No extra cost for Installation and Training.
                        </label>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Right Section (Features) */}
              <div className="col-12 col-md-6 mt-3 ">
                <h5
                  className="ms-4 "
                  style={{
                    // marginRight: "20px",
                    fontWeight: "600",
                    fontSize: "20px",
                    color: "#f39c12",
                    // marginLeft: "15px",
                  }}
                >
                  Features
                </h5>
                <ul
                  style={{
                    marginLeft: "25px",
                    // fontWeight: "600",
                    // fontSize: "20px",
                    // color: "#f39c12",
                  }}
                >
                  <li>Order Purchase</li>
                  <li>Purchase</li>
                  <li>Purchase Return</li>
                  <li>Sales</li>
                  <li>Sales Return</li>
                  <li>Sales Account</li>
                  <li>Purchase Account</li>
                  <li>Current Stock</li>
                  <li>Pharmacy Summary Reports</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* ==========================================Model==================
         */}

        {isModalOpen && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={this.closeModal}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                width: "400px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h4>Book Your Free Demo Here</h4>

              <form onSubmit={this.handleSubmit}>
                <div className="mt-3">
                  <label htmlFor="firstName">First Name:</label>
                  <input
                    type="text"
                    name="fname"
                    value={fname}
                    onChange={this.handleChange}
                    placeholder="first name"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="lastName">Last Name:</label>
                  <input
                    name="lname"
                    type="text"
                    value={lname}
                    onChange={this.handleChange}
                    placeholder="last name"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="email">Mobile No.:</label>
                  <input
                    name="email"
                    // type="email"
                    value={email}
                    onChange={this.handleChange}
                    placeholder="mobile no."
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div>
                {/* <div className="mt-3">
                  <label htmlFor="subject">Subject:</label>
                  <input
                    name="subject"
                    type="text"
                    value={subject} // This will now show the static value
                    onChange={this.handleChange}
                    placeholder="subject"
                    required
                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                  />
                </div> */}

                <div
                  className="button-group"
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    type="button"
                    onClick={this.closeModal}
                    style={{
                      margin: "0 6px",
                      padding: "10px 20px",
                      backgroundColor: "#3498db",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2980b9";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3498db";
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    style={{
                      margin: "0 6px",
                      padding: "10px 20px",
                      backgroundColor: "#3498db",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2980b9"; // Change background color on hover
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3498db"; // Reset background when mouse leaves
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Pharmacy;
